import { render } from "./AllPermitsMenu.vue?vue&type=template&id=4f41f8fe"
import script from "./AllPermitsMenu.vue?vue&type=script&lang=js"
export * from "./AllPermitsMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__